import _ from "lodash";
import PropTypes from "prop-types";
import React from "react";
import { Container, Dropdown, Image, Menu } from "semantic-ui-react";
import { inject, observer } from "mobx-react";
import logo from "resources/logo.png";
import Auth from "stores/Auth";
import { withRouter } from "react-router";

const NavbarDesktop = ({ leftItems, rightItems, auth, history }) => (
  <Menu fixed="top" inverted>
    <Container>
      <Menu.Item>
        <Image size="tiny" src={logo} />
      </Menu.Item>
      {_.map(leftItems, item => <Menu.Item {...item} />)}
      <Menu.Menu position="right">
        {auth.managerToken &&
          auth.user.role === "patient" && (
            <Menu.Item>
              <a
                href="javascript:void(0)"
                onClick={() => {
                  auth.exitImpersonation().then(() => history.push("/app"));
                }}
              >
                {auth.role === 'practitioner' ? 'Go back to Practitioner View' : 'Go back to Manager View'}
              </a>
            </Menu.Item>
          )}
        <Dropdown text={auth?.user?.fullName} pointing className="link item">
          <Dropdown.Menu>
            {_.map(rightItems, item => <Dropdown.Item {...item} />)}
          </Dropdown.Menu>
        </Dropdown>
      </Menu.Menu>
    </Container>
  </Menu>
);

NavbarDesktop.propTypes = {
  leftItems: PropTypes.arrayOf(PropTypes.object),
  rightItems: PropTypes.arrayOf(PropTypes.object)
};

export default withRouter(inject("auth")(observer(NavbarDesktop)));



// WEBPACK FOOTER //
// ./src/components/Navbar/NavbarDesktop.js